import img1 from "../assets/asset_14.png";
import img2 from "../assets/asset_15.png";

const Roadmap = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center my-5 py-5 position-relative">
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
          width: " 100%",
          height: "100%",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1549068106-b024baf5062d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(125px) brightness(0.4) contrast(2)",
        }}
      />
      <br />
      <h1
        className="primary-h"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="700"
      >
        ROADMAP
      </h1>
      <img
        src={img1}
        alt=""
        style={{
          position: "absolute",
          right: "-10%",
          width: "30%",
          bottom: 0,
          top: "20%",
          filter:
            "drop-shadow(0px 0px 4px var(--primary)) drop-shadow(-0px -0px 2px var(--secondary)) drop-shadow(-0px -0px 50px rgba(var(--primary-rgb), 0.5))",
        }}
      />
      <img
        src={img2}
        alt=""
        style={{
          position: "absolute",
          left: "-12%",
          width: "35%",
          bottom: 0,
          top: "50%",
          transform: "scaleX(-1)",
          filter:
            "drop-shadow(0px 0px 4px var(--primary)) drop-shadow(-0px -0px 2px var(--secondary)) drop-shadow(-0px -0px 50px rgba(var(--primary-rgb), 0.5))",
        }}
      />
      <br />
      <div className="roadmap">
        <div
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>
              ✅ Confirmed reports received of a Galactic Laser Octopus crash
              landing on Planet Earth
            </p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>✅ Laser Octopus LLC creation</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>✅ Laser Octopus logo and mascot trademark</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>✅ Laser Octopus website launchh</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="350"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>✅ Merch launch</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>✅ Laser Octopus Arcade (Desktop) creation - stages 1 - 3</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>✅ Laser Octopus Arcade copyright</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>✅ Laser Octopus Arcade launch</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="350"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>✅ Laser Octopus Club NFTs collection generation</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="400"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>✅ Laser Octopus Club NFTs minting live</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="450"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>Laser Octopus Arcade - stages 4 - 6</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>New merch</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>Skateboard decks</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>
              20% of all initial NFT sales profits donations to charities
              dedicated to the sustainability of our oceans and the recovery of
              childhood abuse and trauma
            </p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="350"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>
              Spinoff NFT project from a Laser Octopus Arcade mystery character
            </p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="400"
          data-aos-duration="700"
          className="roadmap-item right"
        >
          <div className="content">
            <p>More charity donations for the benefit of Humanity</p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="450"
          data-aos-duration="700"
          className="roadmap-item left"
        >
          <div className="content">
            <p>Surprise collaborations (tentative)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
